// src/pages/WhatsAppConnect/index.js
import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button, Badge } from "reactstrap";

import { api, urls } from "../../api/api";

export default function WhatsAppConnect() {
  document.title = "WhatsApp Connect";

  // disconnected | connecting | qr | connected
  const [status, setStatus] = useState("disconnected");
  const [qr, setQr] = useState(null); // dataURL
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const statusUi = useMemo(() => {
    if (status === "connected")
      return { color: "success", text: "Connected", hint: "WhatsApp is connected ✅" };

    if (status === "qr")
      return {
        color: "warning",
        text: "Not connected (scan QR)",
        hint: "Scan the QR to link WhatsApp Web.",
      };

    if (status === "connecting")
      return { color: "info", text: "Connecting...", hint: "Trying to connect..." };

    return { color: "secondary", text: "Disconnected", hint: "Worker is not connected." };
  }, [status]);

  const load = async () => {
    setLoading(true);
    setErr("");
    try {
      // status via Backend
      const s = await api.get(urls.waStatus);
      const sj = s.data;
      const nextStatus = sj.status || "disconnected";
      setStatus(nextStatus);

      // qr via Backend
      const r = await api.get(urls.waQr);
      const rj = r.data;

      if (nextStatus === "connected") {
        setQr(null);
      } else {
        setQr(rj.qr || null);
      }

      if (rj.error) setErr(String(rj.error));
    } catch (e) {
      setErr("Le backend n'arrive pas à joindre le service WhatsApp.");
      setStatus("disconnected");
      setQr(null);
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    if (!window.confirm("Logout WhatsApp باش تولّي QR جديد؟")) return;
    setLoading(true);
    setErr("");
    try {
      await api.post("/whatsapp/logout"); // Assurez-vous que cette route existe
      await load();
    } catch (e) {
      setErr("Erreur logout");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="g-3">
          {/* LEFT: status */}
          <Col lg={5}>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <h5 className="mb-2">Statut</h5>

                    <div className="d-flex align-items-center gap-2 mb-2">
                      <Badge color={statusUi.color}>{statusUi.text}</Badge>

                      {/* dot indicator */}
                      <span
                        style={{
                          width: 10,
                          height: 10,
                          borderRadius: 99,
                          display: "inline-block",
                          background:
                            status === "connected"
                              ? "#28a745"
                              : status === "qr"
                                ? "#f0ad4e"
                                : status === "connecting"
                                  ? "#17a2b8"
                                  : "#6c757d",
                        }}
                      />
                    </div>

                    <div className="text-muted" style={{ fontSize: 12 }}>
                      {statusUi.hint}
                    </div>

                    {err ? (
                      <div className="text-danger mt-2" style={{ fontSize: 13 }}>
                        {err}
                      </div>
                    ) : null}
                  </div>

                  <div className="d-flex gap-2">
                    <Button color="secondary" onClick={load} disabled={loading}>
                      {loading ? "..." : "Refresh"}
                    </Button>

                    {/* Logout غير إلا كان connected باش ما يتقلقش */}
                    <Button
                      color="danger"
                      onClick={logout}
                      disabled={loading || status !== "connected"}
                      title={status !== "connected" ? "Connect first" : "Logout"}
                    >
                      Logout
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* RIGHT: QR / Connected card */}
          <Col lg={7}>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">QR Code</h5>
                  <span className="text-muted" style={{ fontSize: 12 }}>
                    {loading ? "Chargement..." : ""}
                  </span>
                </div>

                {status === "connected" ? (
                  <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 320 }}>
                    <div className="text-center">
                      <div style={{ fontSize: 42 }}>✅</div>
                      <div className="fw-semibold mt-2">WhatsApp connected</div>
                      <div className="text-muted" style={{ fontSize: 13 }}>
                        You can send WhatsApp notifications now.
                      </div>
                    </div>
                  </div>
                ) : qr ? (
                  <div className="d-flex flex-column align-items-center" style={{ minHeight: 320 }}>
                    <img
                      src={qr}
                      alt="WhatsApp QR"
                      style={{
                        width: 360,
                        maxWidth: "100%",
                        borderRadius: 10,
                        border: "1px solid #eee",
                      }}
                    />
                    <div className="text-muted mt-2" style={{ fontSize: 12 }}>
                      WhatsApp → Linked devices → Link a device
                    </div>
                  </div>
                ) : (
                  <div className="text-muted" style={{ minHeight: 320 }}>
                    {loading ? "Chargement..." : "QR non disponible. Clique Refresh."}
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
